import React, { createContext, useContext, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { API_URL, authHeaders } from '../utils/api';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Spara user-preferenser i localStorage så PrivateRoute kan läsa dem
  // synkront vid root-redirect (utan att vänta på API-anrop)
  const persistPreferences = (userData) => {
    if (!userData) return;
    if (userData.defaultLandingView) {
      localStorage.setItem('defaultLandingView', userData.defaultLandingView);
    }
  };

  const refreshUserData = async () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        const response = await fetch(`${API_URL}/users/${decoded.id}`, { headers: authHeaders() });
        if (response.ok) {
          const userData = await response.json();
          setUser(userData);
          persistPreferences(userData);
        }
      } catch (error) {
        console.error('Error refreshing user data:', error);
      }
    }
  };

  useEffect(() => {
    const fetchUserData = async () => {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          const decoded = jwtDecode(token);
          const response = await fetch(`${API_URL}/users/${decoded.id}`, { headers: authHeaders() });
          if (response.ok) {
            const userData = await response.json();
            setUser(userData);
            persistPreferences(userData);
          }
        } catch (error) {
          console.error('Error fetching user data:', error);
          localStorage.removeItem('token');
          localStorage.removeItem('role');
        }
      }
      setLoading(false);
    };

    fetchUserData();
  }, []);

  const value = {
    user,
    setUser,
    loading,
    refreshUserData
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}